export default (theme) => ({
    paper: {
        backgroundColor: "#e9edef"
    },
    tabContainer: {
        borderBottom: `1px solid ${theme.palette.primary?.grey || '#e0e0e0'}`,
        minHeight: 48,
        backgroundColor: 'transparent',
    },
    tabButton: {
        minWidth: 0,
        textTransform: 'none',
        padding: '12px',
        marginRight: theme.spacing(0.25),
        backgroundColor: 'transparent',
        borderRadius: '12px',
        fontFamily: 'Inter, sans-serif',
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
        letterSpacing: '0.32px',
        textAlign: 'center',
    },
    /** Figma 359:22863 — inactive segment: grey-20 surface, grey-110 label + icon */
    tabButtonInactive: {
        backgroundColor: 'var(--Greyscale---grey-20, #F2F2F2)',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        color: 'var(--Greyscale---grey-110, #333333)',
        fontWeight: 400,
        '& $tabIconInactive': {
            color: 'var(--Greyscale---grey-110, #333333)',
        },
        borderRadius: '12px',
    },
    tabLabelWithIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    tabIconLabel: {
        flexDirection: 'row',
    },
    /** 16px — Figma Size=16x16; ToggleOn when tab selected */
    tabIconActive: {
        color: 'var(--primary-blue-primary-main, #0F48B8)',
        fontSize: 16,
    },
    /** ToggleOff + grey-110 when Permissions (or other icon tabs) not selected */
    tabIconInactive: {
        color: 'var(--Greyscale---grey-110, #333333)',
        fontSize: 16,
    },
    selectedTabButton: {
        minWidth: 0,
        color: 'var(--primary-blue-primary-main, #0F48B8)',
        backgroundColor: theme.palette.background?.paper || '#fff',
        fontFamily: 'Inter, sans-serif',
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
        letterSpacing: '0.32px',
        textAlign: 'center',
    },
    tabIndicator: {
        height: 2,
        backgroundColor: 'var(--primary-blue-primary-main, #0F48B8)',
        borderRadius: '2px 2px 0 0',
    },
    // Legacy tab styles (when createStaffV2 flag is off)
    tabContainerLegacy: {
        borderBottom: '2px solid #adaeaf',
        minHeight: 48,
    },
    tabButtonLegacy: {
        ...theme.typography.t18,
        minWidth: 0,
    },
    selectedTabButtonLegacy: {
        ...theme.typography.bold,
        minWidth: 0,
    },
    tabIndicatorLegacy: {
        height: 5,
    },
    userProfileWrapper: {
        padding: '25px 20px'
    },
    userProfileHeading: {
        ...theme.typography.t35,
        ...theme.typography.bold,
        letterSpacing: '-0.08px',
        color: theme.palette.primary.jetBlack,
        lineHeight: '46px'
    },
    blueIconContainer: {
        backgroundColor: theme.palette.primary.cobalt,
        borderRadius: '100%',
        padding: 15,
        width: 45,
        height: 45,
        "& svg": {
            fontSize: 45,
            color: theme.palette.primary.white
        }
    },
    inactiveAccordion: {
        flexDirection: 'column'
    },
    userId: {
        ...theme.typography.t16,
        ...theme.typography.medium,
        letterSpacing: '1.5px',
        color: theme.palette.primary.main,
        lineHeight: '21px'
    },
    userProfileInfoWrapper: {
        marginLeft: 20
    },
    metaMainText: {
        ...theme.typography.t25,
        letterSpacing: '1.15px',
        lineHeight: '33px',
        color: theme.palette.primary.jetBlack,
    },
    metaSubText: {
        ...theme.typography.t16,
        letterSpacing: '1.5px',
        lineHeight: '21px',
        ...theme.typography.medium,
        color: theme.palette.primary.main,
    },
    blueBtn: {
        marginTop: 10,
        minWidth: 150,
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        }
    },
    actionContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    profileHeaderPillButton: {
        minWidth: 140,
        textTransform: 'none',
        fontWeight: 700,
    },
    profileHeaderReactivatePillButton: {
        border: '1px solid var(--tonal-palette-aqua-deep-20, #007E87)',
        color: 'var(--tonal-palette-aqua-deep-20, #007E87)',
        backgroundColor: 'transparent',
        '&:hover': {
            border: '1px solid var(--tonal-palette-aqua-deep-20, #007E87)',
            backgroundColor: 'rgba(0, 126, 135, 0.06)',
        },
    },
    contentAreaContainer: {
        borderBottom: `1px solid ${theme.palette.primary.grey}`
    },
    contentSectionPadding: {
        padding: '10px 30px'
    },
    contentAreaChip: {
        borderRadius: 4,
        padding: '0px 5px',
        ...theme.typography.t16,
        ...theme.typography.medium,
        letterSpacing: '1.43px',
        lineHeight: '15.7px'
    },
    blueBox: {
        backgroundColor: theme.palette.primary.main
    },
    blueBoxTitle: {
        ...theme.typography.t14,
        letterSpacing: '0.07px',
        color: theme.palette.primary.white,
        display: 'flex',
        alignItems: 'center'
    },
    blueBoxValue: {
        ...theme.typography.bold,
        ...theme.typography.t30,
        letterSpacing: '0.07px',
        color: theme.palette.primary.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    allActive: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.white,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        }
    },
    infographicBtn: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    daysSelectionList: {
        display: "flex"
    },
    daysSelectionItem: {
        width: "initial",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        height: 40,
        fontSize: 18,
        color: theme.palette.primary.cobalt,
        fontWeight: "bold",
        "&:first-child": {
            borderTopLeftRadius: 20,
            borderBottomLeftRadius: 20
        },
        "&:last-child": {
            borderTopRightRadius: 20,
            borderBottomRightRadius: 20
        }
    },
    activeDay: {
        backgroundColor: theme.palette.primary.cobalt,
        color: "white",
        "&:hover": {
            backgroundColor: theme.palette.primary.cobalt
        }
    },
    profileMargin: {
        margin: '95px 15px 0px'
    },
    facilitiesSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(2),
        gap: theme.spacing(2),
    },
    facilitiesHeading: {
        ...theme.typography.t25,
        ...theme.typography.bold,
        marginBottom: theme.spacing(1),
        color: theme.palette.primary?.jetBlack || theme.palette.text.primary,
    },
    facilitiesExplainer: {
        ...theme.typography.t16,
        marginBottom: 0,
        color: theme.palette.text.secondary,
    },
    addFacilityBtn: {
        flexShrink: 0,
        textTransform: 'none',
        minWidth: 140,
    },
    deactivateConfirmLockPersonIcon: {
        fontSize: 26,
        color: '#D32F2F',
        fill:'none'
    },
    deactivateConfirmHeadline: {
        marginTop: 0,
        color: 'var(--Navy---navy-main, #061E44)',
        fontFamily: 'Inter, sans-serif',
        fontSize: 20,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
    },
    deactivateConfirmDescription: {
        margin: 0,
        color: theme.palette.text?.secondary || '#757575',
        fontFamily: 'Inter, sans-serif',
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
    },
});

/**
 * Layout overrides for @orijinworks/frontend-commons Modal (slots only accept sx).
 * Shell layout matches design spec; danger icon/button colors come from commons.
 */
export const deactivateConfirmModalSlotStyles = {
    mainWrapperStyles: {
        display: 'flex',
        width: 420,
        minWidth: 420,
        maxWidth: 580,
        flexDirection: 'column',
        alignItems: 'flex-start',
        height: 'auto',
    },
    modalHeaderStyles: {
        display: 'flex',
        justifyContent: 'space-between',
        alignSelf: 'stretch',
        padding: '24px',
    },
    modalBodyStyles: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '16px',
        alignSelf: 'stretch',
        borderBottom: 'none',
        padding: '24px',
    },
    modalFooterStyles: {
        display: 'flex',
        height: 80,
        alignItems: 'center',
        '&.modal-footer': {
            "justify-content":"flex-end !important",
            '& > div': {
                flexDirection:'row-reverse !important' ,
                '& > button': {
                    marginLeft: '10px !important',
                },
            },
        },
    },
};